module.exports = __webpack_public_path__ + "img/diagram_tablet.e7ddae98.svg";